import { render, staticRenderFns } from "./HiddenListDetail.vue?vue&type=template&id=066bf88e&scoped=true"
import script from "./HiddenListDetail.vue?vue&type=script&lang=js"
export * from "./HiddenListDetail.vue?vue&type=script&lang=js"
import style0 from "./HiddenListDetail.vue?vue&type=style&index=0&id=066bf88e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066bf88e",
  null
  
)

export default component.exports